import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';

export const PROFILE_IMAGE_UPDATED_AT_KEY = 'mw_profile_image_updated_at';

export const getUploadedProfileImageName = (userId: string | null | undefined) => {
  const normalizedUserId = String(userId || '').trim();

  return normalizedUserId ? `${normalizedUserId}.jpg` : '';
};

export const buildProfileImageUrl = (
  image: string | null | undefined,
  cacheKey: string | number | null | undefined = Date.now()
) => {
  const normalizedImage = String(image || '').trim();

  if (!normalizedImage) {
    return '';
  }

  return `${GET_BASE_URL_IMAGE}/disneyland/images/userimg/${normalizedImage}?v=${encodeURIComponent(
    String(cacheKey || Date.now())
  )}`;
};
